import React, { useState, createContext, useEffect, useContext} from "react"
import detectBrowserLanguage from 'detect-browser-language'

import drapeauFR from '../images/drapeau_FR.svg';
import drapeauEN from '../images/drapeau_EN.svg';

export const LanguageContext = createContext()

const allLanguages = [
  {"id" : "fr", "flag" : drapeauFR },
  {"id" : "en", "flag" : drapeauEN },
]

const values = {
  passwordValidation:{
    required : {
      "fr" : "Veuillez entrer un mot de passe",
      "en" : "Please enter a password"
    },
    match1 : {
      "fr" : "Doit contenir au moins 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre et un caractère spécial",
      "en" : "Must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    match2 : {
      "fr" : "Doit contenir au moins 1 majuscule et 1 minuscule",
      "en" : "Must contain at least 1 uppercase letter and 1 lowercase letter"
    },
    match3 : {
      "fr" : "Doit contenir au moins 1 chiffre et un caractère spécial (les symboles + et = ne sont pas valides)",
      "en" : "Must contain at least one digit and one special character (the symbols + and = are not valid)"
    },
    min : {
      "fr" : "Doit contenir au moins 8 caractères",
      "en" : "Must contain at least 8 characters"
    },
    confirmSame : {
      "fr" : "Les mots de passe doivent correspondre",
      "en" : "Passwords must match"
    }
  },
  authError : {
    "fr" : "Vous avez été déconnecté, redirection dans 10 secondes",
    "en" : "You have been disconnected, redirecting in 10 seconds",
  },
  error : {
    "fr" : "Erreur",
    "en" : "Error"
  },
  notifSaveModif : {
    "fr" : "Modifications enregistrées !",
    "en" : "Saved changes !"
  },
  notifError : {
    "fr" : "Une erreur est survenue !",
    "en" : "An error has occurred !"
  },
  areYouSure : {
    "fr" : "Êtes-vous sûrs ?",
    "en" : "Are you sure ?"
  },
  language : {
    "fr" : "Français",
    "en" : "English",
  },
  page404 : {
    "fr" : "La page que vous recherchez ne se trouve pas ici",
    "en" : "The page you are looking for isn’t here",
  },
  requiredField : {
    "fr" : "Champ requis",
    "en" : "Required field",
  },
  search : {
    "fr" : "Chercher ...",
    "en" : "Search ...",
  },
  close : {
    "fr" : "Fermer",
    "en" : "Close",
  },
  save : {
    "fr" : "Enregistrer",
    "en" : "Save",
  },
  continue : {
    "fr" : "Continuer",
    "en" : "Continue",
  },
  validate : {
    "fr" : "Valider",
    "en" : "Validate",
  },
  modalMustLandscape : {
    title : {
      "fr" : "Orientation",
      "en" : "Orientation",
    },
    text : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode paysage",
      "en" : "For a better experience, we advise you to use your device in landscape mode",
    }
  },
  modalMustPortrait : {
    title : {
      "fr" : "Orientation",
      "en" : "Orientation",
    },
    text : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode portrait",
      "en" : "For a better experience, we advise you to use your device in portrait mode",
    }
  },
  formation : {
    seuil : {
      "fr" : "Seuil",
      "en" : "Limit",
    },
    pending : {
      "fr" : "En attente",
      "en" : "Pending",
    },
    yourAnswer : {
      "fr" : "Votre réponse",
      "en" : "Your answer",
    },
    pageTitle : {
      "fr" : "Formation",
      "en" : "Training",
    },
    multipleAnswers : {
      "fr" : "Plusieurs réponses sont possibles",
      "en" : "Several answers are possible"
    },
    formatVideo : {
      buttonNext : {
        "fr" : "Suivant",
        "en" : "Next",
      },
    },
    planCours : {
      completed : {
        "fr" : "Complété",
        "en" : "Completed",
      },
      comingUp : {
        "fr" : "À suivre",
        "en" : "Coming up",
      },
    },
  },
  formats : {
    "Titre" : {
      "fr" : "Titre",
      "en" : "Title",
    },
    "Texte" : {
      "fr" : "Intro",
      "en" : "Intro"
    },
    "Video" : {
      "fr" : "Vidéo",
      "en" : "Video"
    },
    "Quizz" : {
      "fr" : "Quizz",
      "en" : "Quizz",
    },
    "QuestionnaireV2" : {
      "fr" : "Question",
      "en" : "Question",
    },
    "Diagnostic" : {
      "fr" : "Diagnostique",
      "en" : "Diagnostic",
    },
    "InputTexte" : {
      "fr" : "Champ texte",
      "en" : "Text field"
    },
  },
  myCertif : {
    pageTitle : {
      "fr" : "Ma certification",
      "en" : "My certification",
    },
    homeWelcome : {
      "fr" : "Ton chemin vers la certification",
      "en" : "Your path to certification",
    },
    homeWelcomeSub : {
      "fr" : "Bienvenue dans votre dashboard personnalisé.",
      "en" : "Welcome to your personalized dashboard.",
    },
    year : {
      "fr" : "Année",
      "en" : "Year",
    },
    skillsList : {
      "fr" : "Liste des soft skills",
      "en" : "List of soft skills"
    },
    buttonDownload : {
      "fr" : "Télécharger le certificat",
      "en" : "Download certificate",
    },
    buttonNotAvailable : {
      "fr" : "Disponible à la fin",
      "en" : "Available at the end",
    },
    tuto : {
      "fr" : "Quelques explications ...",
      "en" : "Some explanations...",
    },
    certificateName : {
      "fr" : "Certificat",
      "en" : "Certificate",
    }
  },
  dashboard : {
    yourProgram : {
      "fr" : "Votre programme",
      "en" : "Your program",
    },
    expertDesc : {
      "fr" : "Docteur en Neurosciences",
      "en" : "Doctor in Neurosciences",
    },
    resources : {
      "fr" : "Ressources",
      "en" : "Resources",
    },
    myStats : {
      "fr" : "Mes stats",
      "en" : "My stats",
    },
    resultModal : {
      title : {
        "fr" : "Mon résultat",
        "en" : "My result",
      },
    },
    resourcesCard : {
      title : {
        "fr" : "Plus d'infos sur les soft skills",
        "en" : "Learn more about soft skills",
      },
      subTitle : {
        "fr" : "Consultez la liste soft skills et comment nous les évaluons",
        "en" : "View the list of soft skills and how we calculate them",
      },
      dictionary : {
        "fr" : "Dictionnaire des soft skills",
        "en" : "Soft skills dictionary",
      }
    },
    cards : {
      modulesAverage : {
        "fr" : "Moy. des modules",
        "en" : "Modules average",
      },
      modules : {
        "fr" : "Modules",
        "en" : "Modules",
      },
      progression : {
        "fr" : "Progression",
        "en" : "Progression",
      },
      groupeAverage : {
        "fr" : "Moyenne groupe",
        "en" : "Group average",
      },
      softSkills : {
        "fr" : "Soft Skills",
        "en" : "Soft Skills",
      },
      time : {
        "fr" : "Moy. temps passé",
        "en" : "Average time",
      },
    },
    stepper : {
      completed : {
        "fr" : "Complété",
        "en" : "Completed",
      },
      closed : {
        "fr" : "Fermé",
        "en" : "Closed",
      },
      daysLeft : {
        "fr" : " jours restants",
        "en" : " days left",
      },
      hoursLeft : {
        "fr" : "Quelques heures restantes",
        "en" : "Few hours remaining",
      },
      seeResultsBtn : {
        "fr" : "Voir résultats",
        "en" : "See results",
      },
      startBtn : {
        "fr" : "Commencer",
        "en" : "Start",
      },
      resumeBtn : {
        "fr" : "Reprendre",
        "en" : "Resume",
      }
    },
  },
  onBoarding : {
    title : {
      "fr" : "Entrez vos informations",
      "en" : "Enter your information",
    },
    sexe : {
      "fr" : "Sexe",
      "en" : "Sexe",
    },
    age : {
      "fr" : "Date de naissance",
      "en" : "Date of birth",
    }
  },
  errorLogin : { //errorLogin page
    title : {
      "fr": "Une erreur est survenue",
      "en" : "An error has occurred",
    },
    texte : {
      "fr" : "Nous sommes désolés mais votre compte n’existe pas.\n\nRapprochez vous de votre école pour leur signaler ce problème et qu’il puisse créer votre compte rapidement.",
      "en" : "We're sorry but your account does not exist.\n\nContact your school to report this problem to them so they can create your account quickly.",
    },
    button : {
      "fr" : "Retour",
      "en" : "Back",
    },
  },
  noAccess : { //noAccess page
    title : {
      "fr": "Une erreur est survenue",
      "en" : "An error has occurred",
    },
    texte : {
      "fr" : "Vos droits ont expirés. Vous n’avez plus accès à ce compte.\n\nVous serez déconnecté dans quelques secondes.",
      "en" : "Your rights have expired. You no longer have access to this account.\n\nYou will be logged out in a few seconds.",
    },
    button : {
      "fr" : "Se déconnecter",
      "en" : "Log Out",
    },
  },
  myAccount : {
    title : {
      "fr" : "Compte",
      "en" : "Account",
    },
    changeNames : {
      "fr" : "Noms",
      "en" : "Names",
    },
    changePassword : {
      "fr" : "Mot de passe",
      "en" : "Password",
    },
    changeLanguage : {
      "fr" : "Langue",
      "en" : "Language",
    },
    name : {
      "fr" : "Nom",
      "en" : "Name",
    },
    poste : {
      "fr" : "Nom entreprise / école",
      "en" : "Company / School name",
    },
    oldPassword : {
      "fr" : "Mot de passe actuel",
      "en" : "Current password",
    },
    newPassword : {
      "fr" : "Nouveau mot de passe",
      "en" : "New password",
    },
    newPasswordConfirm : {
      "fr" : "Confirmer nouveau mot de passe",
      "en" : "Confirm new password",
    },
    wrongOldPassword : {
      "fr" : "Mauvais mot de passe",
      "en" : "Wrong password",
    },
  },
  studentMenu : {
    dashboard : {
      "fr" : "Dashboard",
      "en" : "Dashboard",
    },
    myCertif : {
      "fr" : "Ma certification",
      "en" : "My certification",
    },
    ressources : {
      "fr" : "Ressources",
      "en" : "Resources"
    }
  },
  globalMenu : {
    help : {
      "fr" : "Aide",
      "en" : "Help",
    },
    account : {
      "fr" : "Mon Compte",
      "en" : "My Account",
    },
    logOut : {
      "fr" : "Se déconnecter",
      "en" : "Log Out",
    },
    logOutSubTitle : {
      "fr" : "Vous allez vous déconnecter de votre compte",
      "en" : "You’re going to logout of your account",
    },
    admin : {
      "fr" : "Admin",
      "en" : "Admin",
    }
  },
  adminDashboard : {
    dashCertif : {
      yearBtn : {
        "fr" : "Année ",
        "en" : "Year ",
      },
      catEfficacite : {
        "fr" : "Éfficacité\nopérationnelle",
        "en" : "Operational\nefficiency",
      },
      catInnovation : {
        "fr" : "Innovation et\ncommunication",
        "en" : "Innovation and\ncommunication",
      },
      catCollaboration : {
        "fr" : "Collaboration et\nleadership",
        "en" : "Collaboration and\nleadership",
      },
    },
    exportTable : {
      "fr" : "Exporter le tableau",
      "en" : "Export the data",
    },
    monitoringTable : {
      oui : {
        "fr" : "Oui",
        "en" : "Yes",
      },
      non : {
        "fr" : "Non",
        "en" : "No",
      },
      rattrapage : {
        "fr" : " (R)",
        "en" : " (C)",
      },
      rattrapageExport : {
        "fr" : "Rattrapage",
        "en" : "Catch-up",
      },
      name : {
        "fr" : "Nom",
        "en" : "Name",
      },
      certification : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      module : {
        "fr" : "Module",
        "en" : "Module",
      },
      score : {
        "fr" : "Statut",
        "en" : "Status",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      sector : {
        "fr" : "Nom de diplôme",
        "en" : "Diploma name",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      graduationYear : {
        "fr" : "Année de certification",
        "en" : "Certification year",
      },
      statusProgress : {
        "fr" : "Complété à ",
        "en" : "Completed at "
      },
      statusNotStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started"
      },
      statusEnded : {
        "fr" : "Terminé",
        "en" : "Ended"
      },
      graduation : {
        "fr" : "Diplôme",
        "en" : "Graduation",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    filters : {
      addFilter : {
        "fr" : "Sélectionner Filtres",
        "en" : "Select Filters",
      },
      deleteAll : {
        "fr" : "Tout supprimer",
        "en" : "Remove all",
      },
      delete : {
        "fr" : "Vider",
        "en" : "Clear",
      },
      moduleName : {
        "fr" : "Nom du module",
        "en" : "Module name",
      },
      moduleNameSub : {
        "fr" : "Formations",
        "en" : "Training",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      moduleTypeSub : {
        "fr" : "Types",
        "en" : "Types",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      studyYearSub : {
        "fr" : "Années d'études",
        "en" : "Years of study",
      },
      graduationYear : {
        "fr" : "Année de certification",
        "en" : "Certification year",
      },
      graduationYearSub : {
        "fr" : "Années de Certification",
        "en" : "Certification years",
      },
      groupe : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      groupeSub : {
        "fr" : "Certifications",
        "en" : "Certifications",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      campusSub : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      sector : {
        "fr" : "Nom de diplôme",
        "en" : "Diploma name",
      },
      sectorSub : {
        "fr" : "Noms de diplôme",
        "en" : "Diploma names",
      },
      status : {
        "fr" : "Statut",
        "en" : "Status",
      },
      statusSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      levelSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
      progressSub : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    contentType : {
      identif : {
        "fr" : "Évaluation",
        "en" : "Evaluation",
      },
      enrich : {
        "fr" : "Enrichissement",
        "en" : "Enrichment",
      },
      icebreaker : {
        "fr" : "Icebreaker",
        "en" : "Icebreaker",
      }
    },
    statusTypes : {
      notStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      ended : {
        "fr" : "Terminé",
        "en" : "Finished",
      },
      endedInRat : {
        "fr" : "Terminé (R)",
        "en" : "Finished (C)",
      }
    },
    levelTypes : {
      notAcquired : {
        "fr" : "Non acquis",
        "en" : "Not acquired",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      acquired : {
        "fr" : "Acquis",
        "en" : "Acquired",
      },
      rattrapage : {
        "fr" : "Rattrapage",
        "en" : "Retake",
      }
    },
    monitoringCards : {
      students : {
        "fr" : "Étudiants total",
        "en" : "Total students",
      },
      modules : {
        "fr" : "Modules",
        "en" : "Modules",
      },
      completion : {
        "fr" : "Taux de complétion",
        "en" : "Completion rate",
      },
      average : {
        "fr" : "Moyenne groupe",
        "en" : "Group average",
      },
      softSkills : {
        "fr" : "Soft Skills",
        "en" : "Soft Skills",
      },
      time : {
        "fr" : "Moyenne temps passé",
        "en" : "Average time spent",
      }
    },
    completionChart : {
      title : {
        "fr" : "Total étudiants ayant fini…",
        "en" : "Total students who finished…",
      },
      average : {
        "fr" : "Total",
        "en" : "Total",
      },
      emptyTitle : {
        "fr" : "Aucune donnée de programme",
        "en" : "No program data",
      },
      emptySubTitle : {
        "fr" : "Commencez à suivre vos progrès en configurant votre premier programme de formation.",
        "en" : "Start tracking your progress by setting up your first training program.",
      }
    },
    softSkillsViewer : {
      emptyTitle : {
        "fr" : "Aucun soft skills",
        "en" : "No soft skills",
      },
      emptySubTitle : {
        "fr" : "Enrichissez votre profil en ajoutant les soft skills que vous souhaitez développer.",
        "en" : "Enhance your profile by adding soft skills you wish to develop.",
      }
    },
    usedSoftSkills : {
      "fr" : "Soft Skills Utilisés",
      "en" : "Applied Soft Skills",
    },
    efficaciteSkills : {
      "fr" : "Efficacité opérationnelle",
      "en" : "Operational effectiveness",
    },
    communicationSkills : {
      "fr" : "Communication et innovation",
      "en" : "Communication and innovation",
    },
    leadershipSkills : {
      "fr" : "Leadership et collaboration",
      "en" : "Leadership and collaboration",
    },
    homePage : {
      monitoringSub : {
        "fr" : "Bienvenue dans votre dashboard personnalisé.",
        "en" : "Welcome to your personalized dashboard.",
      },
      mappingSub : {
        "fr" : "Bienvenue dans votre dashboard personnalisé.",
        "en" : "Welcome to your personalized dashboard.",
      },
      certificationSub : {
        "fr" : "Bienvenue dans votre dashboard personnalisé.",
        "en" : "Welcome to your personalized dashboard.",
      },
      tutoTitle : {
        "fr" : "Une petite introduction",
        "en" : "A little introduction",
      },
      tutoSubTitle : {
        "fr" : "La certification soft skills de votre diplôme",
        "en" : "The soft skills certification of your diploma",
      },
    },
    mappingPage : {
      tutoTitle : {
        "fr" : "Comprendre progression",
        "en" : "Understanding progression",
      },
      tutoSubTitle : {
        "fr" : "La certification soft skills de votre diplôme",
        "en" : "The soft skills certification of your diploma",
      },
      graph : {
        title : {
          "fr" : "Résultats avant/après",
          "en" : "Results before/after",
        },
        subTitle : {
          "fr" : "Niveau de connaissance",
          "en" : "Level of knowledge",
        },
        before : {
          "fr" : "Avant",
          "en" : "Before",
        },
        after : {
          "fr" : "Après",
          "en" : "After",
        },
        legends : {
          "fr" : "Légendes :",
          "en" : "Legends :",
        },
        expectedLevel : {
          "fr" : "Niveau attendu :",
          "en" : "Expected Level :",
        },
        knowledgeBeforeLegend : {
          "fr" : "Connaissance avant",
          "en" : "Knowledge before",
        },
        knowledgeAfterLegend : {
          "fr" : "Connaissance après",
          "en" : "Knowledge after",
        },
        legendSubTitle : {
          "fr" : "Parmi --/-- percentile",
          "en" : "Among --/-- percentile",
        }
      },
    },
    blockModal : {
      topTitle : {
        "fr" : "Débloquez la fonctionnalité",
        "en" : "Upgrade to",
      },
      feature : {
        "fr" : "Fonctionnalité",
        "en" : "Feature",
      },
      subTitle : {
        mapping : {
          "fr" : "Le Mapping soft skills de votre groupe",
          "en" : "The soft skills mapping of your group",
        },
        certification : {
          "fr" : "La certification soft skills de votre diplôme",
          "en" : "The soft skills certification for your diploma",
        },
      },
      card1 : {
        mapping : {
          "fr" : "Découvrez les progrès des étudiants sur leurs connaissances en soft skills",
          "en" : "Discover students’ progress on their soft skills knowledge.",
        },
        certification : {
          "fr" : "Accédez à vos certifications soft skills par diplôme et par année.",
          "en" : "Access your soft skills certifications by degree and by year.",
        },
      },
      card2 : {
        mapping : {
          "fr" : "Cartographier les soft skills de vos étudiants par secteur et année d’études.",
          "en" : "Map your students' soft skills by sector and by the year of study.",
        },
        certification : {
          "fr" : "Retrouvez vos open badges par soft skills et par diplôme.",
          "en" : "Find your open badges with the help of the soft skills and degree.",
        },
      },
      button : {
        "fr" : "Contactez les commerciaux",
        "en" : "Contact Sales Team",
      },
    },
    drawerSearchEcoleMobile : {
      "fr" : "Choisir une école",
      "en" : "Select a school",
    },
    home : {
      "fr" : "Accueil",
      "en" : "Home",
    },
    monitoring : {
      "fr" : "Suivi",
      "en" : "Monitoring",
    },
    mapping : {
      "fr" : "Progression",
      "en" : "Progression",
    },
    certification : {
      "fr" : "Certification",
      "en" : "Certification",
    },
    homeWelcome : {
      "fr" : "Bonjour ",
      "en" : "Hello ",
    },
    homeWelcomeSub : {
      "fr" : "Bienvenue dans votre dashboard personnalisé.",
      "en" : "Welcome to your personalized dashboard.",
    },
    seeTuto : {
      "fr" : "Voir le tutoriel",
      "en" : "See the tutorial",
    },
  },
  mainLayout : {
    needHelp : {
      "fr" : "Besoin d'aide ?",
      "en" : "Need help ?",
    },
    itsHere : {
      "fr" : "C'est ici",
      "en" : "It's here",
    },
    languageTitle: {
      "fr" : "Choisis ta langue",
      "en" : "Choose your language",
    },
    languageSubTitle: {
      "fr" : "Rising up est disponible dans 2 langues",
      "en" : "Rising up is available in 2 languages",
    },
    languageButtonContinue: {
      "fr" : "Continuer en Français",
      "en" : "Continue in English",
    }
  },
  forgotPasswordPage : {
    title : {
      "fr" : "Réinitialiser votre mot de passe",
      "en" : "Reset your password",
    },
    button : {
      "fr" : "Réinitialiser",
      "en" : "Reset",
    },
    afterText : {
      "fr" : "Si votre email existe, un email contenant un lien pour modifier votre mot de passe a été envoyé !",
      "en" : "If your email address exists, an email containing a link to change your password has been sent. !",
    }
  },
  resetPasswordPage : {
    title : {
      "fr" : "Modifier votre mot de passe",
      "en" : "Change your password",
    },
    button : {
      "fr" : "Modifier",
      "en" : "Change",
    },
    afterText : {
      "fr" : "Modification enregistrée !",
      "en" : "Change saved !",
    }
  },
  registerPage : {
    pageTitle : {
      "fr" : "Inscription",
      "en" : "Register",
    },
    title : {
      "fr" : "Entrez le code groupe",
      "en" : "Enter group code",
    },
    codeField : {
      "fr" : "Code groupe",
      "en" : "Group code",
    },
    firstNameField : {
      "fr" : "Votre prénom",
      "en" : "Your firstname",
    },
    lastNameField : {
      "fr" : "Votre nom",
      "en" : "Your lastname",
    },
    ruTexte : {
      "fr" : "J'accepte les ",
      "en" : "I agree to the ",
    },
    ruTitle : {
      "fr" : "conditions générales d'utilisation",
      "en"  : "terms of use"
    },
    invalidCode : {
      "fr" : "Ce code n'existe pas",
      "en" : "This code does not exist",
    },
    alreadyUseEmail : {
      "fr" : "L'e-mail est déjà utilisée",
      "en" : "The email address is already in use",
    },
    confirmDialog : {
      title : {
        "fr" : "Vérifiez vos informations",
        "en" : "Check your information",
      },
      subTitle : {
        "fr" : "Tout changement ne sera plus possible dès lors que vous cliquez sur “Continuer”",
        "en" : "Any changes will no longer be possible once you click “Continue”",
      },
    },
  },
  loginPage : {
    title : {
      "fr" : "Connexion",
      "en" : "Login",
    },
    emailField : {
      "fr" : "Adresse email",
      "en" : "Email address",
    },
    passwordField : {
      "fr" : "Mot de passe",
      "en" : "Password",
    },
    forgotPassword : {
      "fr" : "Mot de passe oublié ?",
      "en" : "Forgotten password ?",
    },
    eduServicesLogin : {
      "fr" : "Se connecter avec EduServices",
      "en" : "Login with EduServices",
    },
    button : {
      "fr" : "Se connecter",
      "en" : "Login",
    },
    noAccount : {
      "fr" : "Pas de compte ?",
      "en" : "No account ?",
    },
    alreadyAccount : {
      "fr" : "Déjà un compte ?",
      "en" : "Already have an account ?",
    },
    incorrectMessage : {
      "fr" : "Identifiants inconnus",
      "en" : "Unknown credentials",
    },
  }
}

const LanguageProvider = ({ children }) => {

  const [language, setLanguage] = useState(null)
  const [flag, setFlag] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [modalChangeLanguage, setModalChangeLanguage] = useState(false)

  const changeLanguage = (newLanguage) => {
    let findFlag = allLanguages.find((el) => el.id === newLanguage)
    setFlag(findFlag?.flag)
    setLanguage(newLanguage)
  }

  useEffect(() => {
    let detectLanguage = detectBrowserLanguage()
    let tmpLanguage = "en"
    if (detectLanguage.includes("fr-")) {
      tmpLanguage = "fr"
    }
    let findFlag = allLanguages.find((el) => el.id === tmpLanguage)
    setFlag(findFlag?.flag)
    setLanguage(tmpLanguage)
    setIsLoading(true)
  }, [])


  return (
    <LanguageContext.Provider
      value={{
        actLanguage : language,
        actLanguageFlag : flag,
        languageValues : values,
        changeLanguage,
        modalChangeLanguage,
        setModalChangeLanguage,
        allLanguages,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext

export { LanguageProvider }
